import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { CardWrapper, LogoLogin, PBemVindo, PAcessarSuaConta, CustomErrorMessage, ActionsWrapper } from './AuthCard';
import { PrimaryTextColor } from '../../../app/theme/tokens/colors';
import { Spinner } from '../../../shared/ui/Spinners';
import { PrimaryButton } from '../../../shared/ui/Inputs';
import { LoginService } from '../../../services/auth';

const loginService = LoginService;

const safeDecodeParam = (val: string | null) => {
    if (!val) return val;
    try {
        let decoded = decodeURIComponent(val);
        if (decoded && decoded.indexOf('%') >= 0) {
            try {
                decoded = decodeURIComponent(decoded);
            } catch (e) {
                console.error('Error decoding param:', e);
            }
        }
        return decoded;
    } catch (err) {
        return val;
    }
};

export const EmailConfirmSignupCard: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [status, setStatus] = useState<'loading' | 'success' | 'error'>('loading');
    const [feedback, setFeedback] = useState('');

    const code = safeDecodeParam(searchParams.get('code'));
    const username = safeDecodeParam(searchParams.get('username'));

    useEffect(() => {
        if (!code || !username) {
            setStatus('error');
            setFeedback('Link inválido ou incompleto.\nAcesse novamente a partir do e-mail recebido ou solicite um novo link.');
            return;
        }

        const confirmEmail = async () => {
            try {
                const isConfirmSignup = await loginService.confirmSignup(username, code);

                if (isConfirmSignup) {
                    setStatus('success');
                    setFeedback('E-mail confirmado com sucesso!\nRedirecionando para definição de senha...');

                    setTimeout(() => {
                        // Redireciona para a página de login passando o username para já iniciar a definição de senha
                        window.location.href = `/login?action=firstAccess&username=${encodeURIComponent(username)}`;
                    }, 2000);
                } else {
                    setStatus('error');
                    setFeedback('Conta já confirmada ou link inválido. Redirecionando para definição de senha...');
                    setTimeout(() => {
                        window.location.href = `/login?action=firstAccess&username=${encodeURIComponent(username)}`;
                    }, 1500);
                }
            } catch (err) {
                console.error('[emailConfirmSignup] erro ao confirmar:', err);
                setStatus('error');
                setFeedback('Conta já confirmada ou link inválido. Redirecionando para definição de senha...');
                setTimeout(() => {
                    window.location.href = `/login?action=firstAccess&username=${encodeURIComponent(username)}`;
                }, 1500);
            }
        };

        confirmEmail();
    }, [code, username]);

    return (
        <CardWrapper>
            <LogoLogin />

            <PBemVindo>
                Bem-vindo ao <b>Portal Homecare</b>
            </PBemVindo>
            <PAcessarSuaConta>Confirmação de e-mail</PAcessarSuaConta>

            {status === 'loading' && (
                <>
                    <p
                        style={{
                            textAlign: 'center',
                            fontSize: 16,
                            color: PrimaryTextColor,
                            marginTop: 8,
                        }}
                    >
                        Estamos confirmando seu e-mail. Aguarde alguns instantes...
                    </p>
                    <div
                        style={{
                            marginTop: 16,
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                    >
                        <Spinner />
                    </div>
                </>
            )}

            {status !== 'loading' && (
                <>
                    {status === 'success' ? (
                        <p
                            style={{
                                textAlign: 'center',
                                fontSize: 16,
                                color: '#1a7f37',
                                whiteSpace: 'pre-line',
                                marginTop: 12,
                            }}
                        >
                            {feedback}
                        </p>
                    ) : (
                        <>
                            <CustomErrorMessage>{feedback}</CustomErrorMessage>
                            <ActionsWrapper>
                                <PrimaryButton onClick={() => (window.location.href = '/login')}>Voltar para tela de login</PrimaryButton>
                            </ActionsWrapper>
                        </>
                    )}
                </>
            )}
        </CardWrapper>
    );
};
